import { KatIcon } from "@amzn/katal-react";
import React, { type FC } from "react";
import { useTranslation } from "react-i18next";
import "./index.css";

type SortDirection = "asc" | "desc" | false;

interface SortDirectionMeta {
  sortIcon: KatIcon.Name;
  ariaSort: "ascending" | "descending" | "none";
}

const SORT_DIRECTION_MAP: Record<"asc" | "desc" | "none", SortDirectionMeta> = {
  asc: { sortIcon: "arrow_upward", ariaSort: "ascending" },
  desc: { sortIcon: "arrow_downward", ariaSort: "descending" },
  none: { sortIcon: "unfold_more", ariaSort: "none" },
};

const getSortMeta = (direction: SortDirection): SortDirectionMeta =>
  SORT_DIRECTION_MAP[direction === false ? "none" : direction];

interface NestErrorSeveritySortHeaderProps {
  sortDirection: SortDirection;
  onToggleSort: () => void;
}

const NestErrorSeveritySortHeader: FC<NestErrorSeveritySortHeaderProps> = ({
  sortDirection,
  onToggleSort,
}) => {
  const { t } = useTranslation();
  const { sortIcon, ariaSort } = getSortMeta(sortDirection);

  return (
    <button
      type="button"
      className="nest-error-sort-btn"
      onClick={onToggleSort}
      aria-label={`${t("aic_nest_history_error_severity")} - ${t("aic_nest_history_error_sort_label")}: ${ariaSort}`}
    >
      {t("aic_nest_history_error_severity")}
      <KatIcon name={sortIcon} size="small" />
    </button>
  );
};

export default NestErrorSeveritySortHeader;
